import { extractMembers, extractPersonFromJsonLd } from '@atlaskit/link-extractors';
export var extractPersonsUpdatedBy = function extractPersonsUpdatedBy(jsonLd) {
  if (jsonLd['@type'] === 'atlassian:Project') {
    var members = extractMembers(jsonLd);
    if (members && members.length !== 0) {
      return members;
    }
  }
  var updatedBy = jsonLd['atlassian:updatedBy'];
  if (updatedBy) {
    var extractedPersons = extractPersonFromJsonLd(updatedBy);
    return extractedPersons ? [extractedPersons] : undefined;
  }
};